import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaEye, FaRegFileExcel } from 'react-icons/fa6';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import Loading from '../../components/Loading';
import AddCaisseCentrale from './AddCaisseCentrale';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';
import { FaEdit } from 'react-icons/fa';
import NumberFormat from '../../components/NumberFormat';


const CaisseCentrales = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [caisseCentrales, setCaisseCentrales] = useState([]);
    const [showAddCaisseCentrale, setShowAddCaisseCentrale] = useState(false);
    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [req, setReq] = useState({
        DateDebut: '',
        DateFin: '',
        exp: '',
    });
    const navigate = useNavigate();

    const supprimer = (caisseCentrale) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/caisseCentrale/' + caisseCentrale.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getCaisseCentrales();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    useEffect(() => {
        getCaisseCentrales();
    }, [])


    const closeAddCaisseCentrale = () => {
        setShowAddCaisseCentrale(false);
        getCaisseCentrales();
    }
    const getCaisseCentrales = () => {
        setLoading(true);
        axiosClient.get('/caisseCentrales')
            .then(response => {
                setCaisseCentrales(response.data.caisseCentrales);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }


    return (
        <>
            <Header title="Caisses Centrale" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            
            
            <div className="flex my-2">
                <h1 className='text-red-500 font-bold'>Total soldes: <NumberFormat valeur={caisseCentrales.reduce((n, { solde }) => n + parseFloat(solde), 0)}/> MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>code</th>
                            <th>CaisseCentrale </th>
                            <th>Agence</th>
                            <th>Utilisateur</th>
                            <th>Solde</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="8"><Loading /></td></tr></tbody> :
                        <tbody>
                            {caisseCentrales.map(o => (
                                <tr>
                                    <td>{o.code}</td>
                                    <td>{o.nom}</td>
                                    <td>{o.user.agence.nom}</td>
                                    <td>{o.user.nom}</td>
                                    <td>{o.solde}</td>
                                    <td>
                                        <div className="flex justify-center w-full items-center gap-2">
                                            <ActionButton onClick={() => {

                                            }} color="bg-blue-500" icon={<FaEdit />} textColor="text-white" title="Modifier" />
                                            <ActionButton onClick={() => supprimer(o)} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Bloquer" />
                                        </div>
                                    </td>
                                </tr>
                            ))

                            }
                        </tbody>
                    }

                </table>
            </div>
            
        </>
    )
}

export default CaisseCentrales